module.exports = __webpack_public_path__ + "img/ax-icon-active.c68b4004.svg";